var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1InstallApplication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.86 50l-12 13-12-13H60V15h4v35h9.86zM43 53.76a23.91 23.91 0 01-17 7 24 24 0 1117-7zm-8.2 1.16l-5.69-11.53a7.28 7.28 0 01-9.69-9.66L7.9 28a20.13 20.13 0 0026.9 26.92zM23.74 39.07A3.24 3.24 0 0026 40a3.24 3.24 0 003.23-3.23 3.232 3.232 0 00-1-2.28 3.19 3.19 0 00-2.28-1A3.24 3.24 0 0023.67 39l.07.07zM44 45.94a20.16 20.16 0 00-18-29.31 20.001 20.001 0 00-9.11 2.19l5.73 11.51a7.3 7.3 0 019.86 9.83L44 45.94z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Install_application.fdf9431e.svg";
export { SvgH1InstallApplication as ReactComponent };